import { render, staticRenderFns } from "./SkillGroupNew.vue?vue&type=template&id=c9ef0282"
import script from "./SkillGroupNew.vue?vue&type=script&lang=js"
export * from "./SkillGroupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports